import moment from 'moment'

/**
 * Gets the assessment display logic for credit worthiness assessments
 * @param {Array} creditWorthinessAssessments - Array of credit worthiness assessments
 * @returns {Object} Object containing assessment data and display flags
 */
export const getCreditWorthinessAssessmentState = (creditWorthinessAssessments = []) => {
  const nonCancelledAssessments = creditWorthinessAssessments.filter(a => a.state !== 'CANCELLED')
  const awaitingPaymentAssessment = nonCancelledAssessments.find(a => a.state === 'AWAITING_PAYMENT')
  const completedAssessments = nonCancelledAssessments.filter(a => a.state === 'COMPLETED')

  // Check if most recent completed assessment is more than a month old
  const mostRecentCompletedAssessment = completedAssessments.length > 0
    ? completedAssessments.reduce((latest, current) =>
        moment(current.applicationDate).isAfter(moment(latest.applicationDate)) ? current : latest
      )
    : null

  const isAssessmentOlderThanMonth = mostRecentCompletedAssessment
    ? moment().diff(moment(mostRecentCompletedAssessment.applicationDate), 'months') >= 1
    : false

  const showGetAssessmentCTA = nonCancelledAssessments.length === 0 || isAssessmentOlderThanMonth
  const showAwaitingPaymentCTA = !!awaitingPaymentAssessment
  const showViewAssessmentsCTA = completedAssessments.length > 0 // && !showAwaitingPaymentCTA

  return {
    nonCancelledAssessments,
    awaitingPaymentAssessment,
    completedAssessments,
    mostRecentCompletedAssessment,
    isAssessmentOlderThanMonth,
    showGetAssessmentCTA,
    showAwaitingPaymentCTA,
    showViewAssessmentsCTA,
    // Return mostRecentCompletedAssessment for use in GetAssessmentCTA
    mostRecentAssessmentForDisplay: mostRecentCompletedAssessment
  }
}
